import React from 'react'

// @ts-expect-error - untyped bundle, same suppression as MediaGridReport.tsx.
import { Carousel } from '@fancyapps/ui'

import '@fancyapps/ui/dist/carousel.css'

//@ts-ignore
import styles from './ProductSceneTab.module.css'

export interface ProductSceneTabProps {
  alt: string
  scenes: readonly string[]
}

const escapeAttr = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;')

// Lifestyle shots of the product in use: swipe through, one dot per scene.
export default function ProductSceneTab({ alt, scenes }: ProductSceneTabProps) {
  const hostRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const host = hostRef.current
    if (!host) return
    const carousel = new Carousel(host, {
      infinite: false,
      preload: scenes.length,
      slides: scenes.map((src) => ({
        html: `<img alt="${escapeAttr(alt)}" src="${escapeAttr(
          src,
        )}" draggable="false">`,
      })),
    })
    return () => {
      carousel.destroy()
      host.replaceChildren()
    }
  }, [alt, scenes])

  return (
    <div className={styles['root']}>
      <div className={`carousel ${styles['carousel']}`} ref={hostRef} />
    </div>
  )
}
